


































































































































































/* eslint-disable */
import { Component, Emit, Prop, Vue, Watch } from 'vue-property-decorator'
import { Apis, Services, Factories } from '@finx/web-repository'
import { locale } from 'moment'
import Provisao from '@/store/Provisao'

@Component

export default class ComponentProvisaoDadosIniciais extends Vue {
  @Prop(Boolean) show

  Messages = Factories.Messages
  user: any = {}
  showDialogDataInicioVigencia: Boolean = false

  loading: any = {
    status: false,
    text: 'Carregando...',
  }

  alert: any = {
    show: false,
    message: '',
  }

  errors: any = {
    getFontesPagadorasLoad: false,
    getLocaisExecucoesLoad: false,
    getOperadorasLoad: false,
  }

  loadings: any = {
    getFontesPagadorasLoad: false,
    getLocaisExecucoesLoad: false,
    getOperadorasLoad: false,
  }

  get showProvisaoDadosIniciais(): Boolean {
    return Provisao.getters.DIALOG_DADOS_INICIAIS
  }

  set showProvisaoDadosIniciais(newValue) {
    Provisao.commit('SET_DIALOG_DADOS_INICIAIS', newValue)
  }

  get getIsEditProvisao() {
    return Provisao.getters.IS_EDIT_PROVISAO
  }

  get provisao() {
    return Provisao.getters.PROVISAO
  }

  get getContratoId() {
    return Provisao.getters.CONTRATO_ID
  }

  get getFontesPagadoras() {
    return Provisao.getters.FONTES_PAGADORAS
  }

  get getFontePagadoraSelected() {
    return Provisao.getters.FONTE_PAGADORA_SELECTED
  }

  get getFontePagadoraId() {
    return Provisao.getters.FONTE_PAGADORA_ID
  }

  get getLocaisExecucoes() {
    return Provisao.getters.LOCAIS_EXECUCOES
  }

  get getLocalExecucaoSelected() {
    return Provisao.getters.LOCAL_EXECUCAO_SELECTED
  }

  get getLocalExecucaoId() {
    return Provisao.getters.LOCAL_EXECUCAO_ID
  }

  get getOperadoras() {
    return Provisao.getters.OPERADORAS
  }

  get getPrestadoraId() {
    return Provisao.getters.PRESTADOR_ID
  }

  get getOperadoraSelected() {
    return Provisao.getters.OPERADORA_SELECTED
  }

  get getOperadoraId() {
    return Provisao.getters.OPERADORA_ID
  }

  get getPlanoOperadoraId() {
    return Provisao.getters.PLANO_OPERADORA_ID
  }

  get getContratoGrupoRemuneracao() {
    return Provisao.getters.CONTRATO_GRUPO_REMUNERACAO
  }

  get getDataProcedimento() {
    return Provisao.getters.DATA_PROCEDIMENTO
  }

  get getNomePaciente() {
    return Provisao.getters.NOME_PACIENTE
  }

  get isEnableSave() {
    return (this.getFontePagadoraId !== ''
      && this.getLocalExecucaoSelected !== ''
      && this.getNomePaciente !== ''
      && this.getDataProcedimento !== ''
      && this.getPlanoOperadoraId !== '')
  }

  set getFontePagadoraSelected(selected) {
    Provisao.dispatch('SET_FONTEPAGAFORA_SELECTED', selected)
    Provisao.dispatch('RESET_LOCAL_EXECUCAO_SELECTED')
    Provisao.dispatch('RESET_OPERADORA_SELECTED')
    Provisao.dispatch('RESET_FUNCAO')
    Provisao.dispatch('RESET_PROFISSIONAIS_EXECUTANTES')
    Provisao.dispatch('RESET_PROCEDIMENTOS')
    Provisao.dispatch('RESET_CALCULADORA')
    Provisao.commit('DIALOG_FUNCAO', false)
    Provisao.commit('SET_BLOQUEAR_RESUMO_PROCEDIMENTOS', true)
    Provisao.dispatch('SET_FUNCOES_STATUS_COLOR', 'secondary')
    Provisao.dispatch('SET_INFORMACOES_ADICIONAIS_STATUS_COLOR', 'secondary')
    Provisao.dispatch('LOAD_FUNCAO_USER_LOGGED', selected.contratoId)
    this.getLocaisExecucoesLoad()
  }

  setLocalExecucaoSelected(selected) {
    Provisao.dispatch('SET_LOCALEXECUCAO_SELECTED', selected)
    Provisao.dispatch('RESET_OPERADORA_SELECTED')
    Provisao.dispatch('RESET_FUNCAO')
    Provisao.dispatch('RESET_PROCEDIMENTOS')
    Provisao.dispatch('RESET_CALCULADORA')
    Provisao.commit('SET_BLOQUEAR_RESUMO_PROCEDIMENTOS', true)
    this.getOperadorasLoad()
  }

  setOperadoraSelected(selected) {
    Provisao.dispatch('SET_OPERADORA_SELECTED', selected)
  }

  setDataProcedimento(selected) {
    Provisao.dispatch('SET_DATA_PROCEDIMENTO', selected)
  }

  resetProvisao() {
    Provisao.dispatch('RESET_PROVISAO')
  }

  setNomePaciente(nomePaciente) {
    Provisao.dispatch('SET_NOME_PACIENTE', nomePaciente)
  }

  async getFontesPagadorasLoad() {
    this.loadings.getFontesPagadorasLoad = true
    this.alert.show = false

    const request = await
    Apis.Contratos.FontesPagadoras.getFontesPagadorasByUserId(this.user.profile.sub)
    const success = Factories.Apis.success(request)

    if (success) {
      Provisao.dispatch('LOAD_FONTESPAGADORAS', request.data)
    } else {
      this.alert.show = true
      this.alert.message = Factories.ErrorMessage(request)
    }

    this.loadings.getFontesPagadorasLoad = false
  }

  async getLocaisExecucoesLoad() {
    this.loadings.getLocaisExecucoesLoad = true
    this.alert.show = false

    const request = await
    Apis.Contratos.LocaisExecucoes.getLocaisExecucoesByContratoId(this.getContratoId)
    const success = Factories.Apis.success(request)

    if (success) {
      Provisao.dispatch('LOAD_LOCAISEXECUCOES', request.data)
    } else {
      this.alert.show = true
      this.alert.message = Factories.ErrorMessage(request)
    }

    this.loadings.getLocaisExecucoesLoad = false
  }

  async getOperadorasLoad() {
    this.loadings.getOperadorasLoad = true
    this.alert.show = false

    const request = await
    Apis.Contratos.Operadoras.getOperadorasByFilters(this.getContratoId, this.getLocalExecucaoId)
    const success = Factories.Apis.success(request)

    if (success) {
      Provisao.dispatch('LOAD_OPERADORAS', request.data)
    } else {
      this.alert.show = true
      this.alert.message = Factories.ErrorMessage(request)
    }

    this.loadings.getOperadorasLoad = false
  }

  async getUser() {
    const user = await Services.Oidc.Auth.getUser()
    this.user = user
    Provisao.dispatch('SET_USER', user)
  }

  async mounted() {
    await this.start()
  }

  async start() {
    await this.getUser()

    if (this.$route.params.action === 'editar') {
      this.loading.status = true
      Provisao.dispatch('SET_DADOS_INICIAIS_STATUS_COLOR', 'success')
      Provisao.dispatch('SET_INFORMACOES_ADICIONAIS_STATUS_COLOR', 'success')
      Provisao.dispatch('SET_FUNCOES_STATUS_COLOR', 'success')
      Provisao.dispatch('SET_IS_EDIT_PROVISAO', true)

      Provisao.dispatch('LOAD_PROVISAO', this.$route.params.producaoid)
        .then(async () => {
          this.getFontesPagadorasLoad().then(async () => {
            let selected = this.getFontesPagadoras.filter(p=> p.contratoId === this.getContratoId
              && p.fontePagadoraId === this.getFontePagadoraId
              && p.prestadorId === this.getPrestadoraId)
              Provisao.dispatch('SET_EDIT_FONTEPAGADORA', selected[0])
              .then(async () => {
                this.getLocaisExecucoesLoad().then(c => {
                  let localExecucao = this.getLocaisExecucoes.filter(p => p.localExecucaoId === this.getLocalExecucaoId)
                  Provisao.dispatch('SET_EDIT_LOCALEXECUCAO_SELECTED', localExecucao[0])
                  .then(async () => {
                    this.getOperadorasLoad().then(async () => {
                      let operadora = this.getOperadoras.filter(p => p.operadoraId === this.getOperadoraId && p.planoOperadoraId === this.getPlanoOperadoraId)
                      if (operadora.length <= 0) {
                        operadora = this.getOperadoras.filter(p => p.operadoraId === this.getOperadoraId)
                      }

                      if ( operadora[0] !== undefined)
                        Provisao.dispatch('SET_EDIT_OPERADORA_SELECTED', operadora[0])
                      this.loading.status = false
                    })
                  })
                })
              })
            })
        })
    } else {
      this.loading.status = false
      this.getFontesPagadorasLoad().then(() => {
        Provisao.dispatch('SET_IS_EDIT_PROVISAO', false)
        Provisao.dispatch('SET_DADOS_INICIAIS_STATUS_COLOR', 'secondary')
        Provisao.dispatch('SET_INFORMACOES_ADICIONAIS_STATUS_COLOR','secondary')
        Provisao.dispatch('SET_FUNCOES_STATUS_COLOR', 'secondary')
        Provisao.commit('RESET_PERFIL_PROFISSIONAL_EXECUTANTE')
        Provisao.dispatch('SET_DATA_PROCEDIMENTO', new Date().toISOString().substr(0, 10))
      })
    }
  }

  @Emit('close')
  close() {
    if (this.isEnableSave) {
      Provisao.dispatch('SET_DADOS_INICIAIS_STATUS_COLOR', 'success')
    } else {
      Provisao.dispatch('SET_DADOS_INICIAIS_STATUS_COLOR', 'secondary')
    }
  }
}
